import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=666d1492&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=666d1492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d1492",
  null
  
)

export default component.exports